const populateBasicFields = (data, setFieldValue) => {
 const {
  cat_code,
  average_price,
  catalogue_discount,
  meta_description,
  meta_title,
  meta_keyword,
  name,
  no_of_product,
  weight,
  description,
  price,
  quantity,
  GST,
  coverImage,
  tag,
  optionType,
  fullcatalogue,
  selection,
  instagramVideo,
 } = data;

 setFieldValue("cat_code", cat_code || "");
 setFieldValue("average_price", average_price || 0);
 setFieldValue("catalogue_discount", catalogue_discount || "");
 setFieldValue("fullcatalogue", fullcatalogue);
 setFieldValue("selection", selection);
 if (catalogue_discount) {
  const catalogPrice = parseFloat(price) || 0;
  const discount = parseFloat(catalogue_discount) || 0;
  const offerPrice = (catalogPrice - catalogPrice * (discount / 100)).toFixed(
   2
  );
  setFieldValue("offer_price", offerPrice);
 }

 setFieldValue("meta_description", meta_description || "");
 setFieldValue("meta_title", meta_title || "");
 setFieldValue("meta_keyword", meta_keyword || "");
 setFieldValue("name", name || "");
 setFieldValue("no_of_product", no_of_product || 0);
 setFieldValue("weight", weight || "");
 setFieldValue("description", description || "");
 setFieldValue("price", price);
 setFieldValue("quantity", quantity);
 setFieldValue("GST", GST || 0);
 setFieldValue("coverImage", coverImage);
 setFieldValue("tag", tag || []);
 setFieldValue("optionType", optionType);
 setFieldValue("postId", instagramVideo?.[0]?.postId || null);
};
const populateAssociations = (data, setFieldValue, setkeywords) => {
 const categoryIds =
  data?.CatalogueCategory?.map((item) => item.category_id) || [];
 const brandIds = data?.CatalogueBrand?.map((b) => b.brand_id) || [];
 const sizeData = data?.CatalogueSize || [];
 const collectionIds = data?.Collection?.map((c) => c.collection_id) || [];
 const homeSectionId = data?.items?.map((item) => item.homeSectionId) || [];

 setFieldValue("category_id", categoryIds);
 setFieldValue("brandIds", brandIds);
 setFieldValue("sizes", sizeData);
 setkeywords(data?.search_keywords || []);
 setFieldValue("collection_id", collectionIds);
 setFieldValue("homeSectionId", homeSectionId);
};
const populateAttributes = (attributeValues, setSelectedValues) => {
 const transformed = {};

 attributeValues.forEach((item) => {
  const attrId = item.attribute_id;
  if (!transformed[attrId]) {
   transformed[attrId] = {
    attribute_id: attrId,
    attributeValue: [],
   };
  }

  transformed[attrId].attributeValue.push({
   id: item.attributeValue_id,
   value: item.value,
  });
 });

 setSelectedValues(transformed);
};

export { populateBasicFields, populateAssociations, populateAttributes };
